import {Chart, LineController, Tooltip, LineElement, PointElement, LinearScale, Title, CategoryScale} from 'chart.js';

Chart.register(LineController, Tooltip, LineElement, PointElement, LinearScale, Title, CategoryScale);

let PriceControlChart = null;

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.style.background = 'rgba(0, 0, 0, 0.7)';
    tooltipEl.style.borderRadius = '3px';
    tooltipEl.style.color = 'white';
    tooltipEl.style.opacity = 1;
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.position = 'absolute';
    // tooltipEl.style.transform = 'translate(-50%, 0)';
    tooltipEl.style.transition = 'all .1s ease';

    const table = document.createElement('table');
    table.style.margin = '0px';

    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};


window.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.more-expensive').forEach(function (el) {
    el.addEventListener('click', (event) => {
      if (PriceControlChart) {
        PriceControlChart.destroy();
        PriceControlChart = null;
      }
      let product_title = $(el).data('product');
      let items = $(el).data('items');
      let $modal = $('#priceChartModal');
      $('.modal-title', $modal).text(product_title);
      let $modalBody = $('.modal-body', $modal);
      if (0 === $modalBody.children('#chart').length) {
        $modalBody.append('<canvas id="chart"></canvas>');
      }
      $modal.modal('show');
      const ctx = document.getElementById('chart').getContext('2d');
      const nums = items.map(item => item.sbis_num);
      const values = items.map(item => item.price);
      PriceControlChart = new Chart(ctx, {
        type: 'line',
        title: 'Контроль цен',
        data: {
          labels: nums,
          datasets: [
            {
              backgroundColor: 'rgb(255, 99, 132)',
              borderColor: 'rgb(255, 99, 132)',
              data: values,
            },
          ],
        },
        options: {
          scales: {
            y: {
              title: {
                display: true,
                text: 'Цена',
              },
            },
            x: {
              title: {
                display: true,
                text: 'Накладные',
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
              external: function (context) {
                const {chart, tooltip} = context;

                let dataPoint = tooltip.dataPoints[0];

                const tooltipEl = getOrCreateTooltip(chart);

                // Hide if no tooltip
                const tooltipModel = tooltip;
                if (tooltipModel.opacity === 0) {
                  tooltipEl.style.opacity = 0;
                  return;
                }

                while (tooltipEl.firstChild) {
                  tooltipEl.firstChild.remove();
                }

                // Set caret Position
                tooltipEl.classList.remove('above', 'below', 'no-transform');
                if (tooltipModel.yAlign) {
                  tooltipEl.classList.add(tooltipModel.yAlign);
                }
                else {
                  tooltipEl.classList.add('no-transform');
                }

                // Set Text
                if (tooltipModel.body) {
                  let item = items[dataPoint.dataIndex];
                  let labels = [];
                  labels.push(`Поставщик: ${item.shipper_title}`);
                  labels.push(`Номер ТТН: ${item.sbis_num}`);
                  labels.push(`Дата: ${item.sbis_date}`);
                  labels.push(`Цена: ${item.formatted_price}`);

                  labels.forEach(function (label, i) {
                    tooltipEl.innerHTML += '<div style="white-space: nowrap;">' + label + '</div>';
                  });
                }


                tooltipEl.style.opacity = 1;

                const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

                let top = positionY + tooltip.caretY;
                if (top >= chart.canvas.clientHeight - tooltip.height) {
                  top -= tooltip.height;
                }

                let left = positionX + tooltip.caretX;
                if (left >= chart.canvas.clientWidth - tooltip.width) {
                  left -= tooltip.width;
                }

                tooltipEl.style.left = left + 'px';
                tooltipEl.style.top = top + 'px';

                tooltipEl.style.padding = tooltip.options.padding + 'px '
                  + tooltip.options.padding + 'px';

                tooltipEl.style.font = chart.ctx.font;
              },
            },
          },
        },
      });
    });
  });
});
